import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { API_BASE_URL } from '../../../config/ApiConfig';
import DefaultModal from './DefaultModal';
import useDefaultModal from '../hooks/useDefaultModal';

function OrgaoFuncionarioModal({ show, onClose, onSuccess, funcionario, orgaoId, departamentos }) {
  const [formData, setFormData] = useState({
    nome: '',
    cpf: '',
    cargo: '',
    email: '',
    telefone: '',
    idDepartamento: '',
    ehUsuario: false,
    situacao: 'ATIVO',
  });
  const [usuarios, setUsuarios] = useState([]);
  const token = localStorage.getItem('token');
  const { setDefaultModal, showDefaultModal } = useDefaultModal();

  useEffect(() => {
    if (show) {
      if (funcionario) {
        setFormData({
          nome: funcionario.nome || '',
          cpf: funcionario.cpf || '',
          cargo: funcionario.cargo || '',
          email: funcionario.email || '',
          telefone: funcionario.telefone || '',
          idDepartamento: funcionario.idDepartamento || '',
          ehUsuario: funcionario.ehUsuario || false,
          situacao: funcionario.situacao || 'ATIVO',
        });
      } else {
        setFormData({
          nome: '',
          cpf: '',
          cargo: '',
          email: '',
          telefone: '',
          idDepartamento: '',
          ehUsuario: false,
          situacao: 'ATIVO',
        });
      }
    }
  }, [show, funcionario]);

  useEffect(() => {
    if (show) {
      axios
        .get(`${API_BASE_URL.USUARIO}/all`, {
          headers: { Authorization: `Bearer ${token}` },
        })
        .then(res => setUsuarios(res.data))
        .catch(() => setUsuarios([]));
    }
  }, [show, token]);

  const handleChange = e => {
    const { name, value, type, checked } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value.toUpperCase(),
    }));
  };

  const handleSubmit = e => {
    e.preventDefault();

    if (!formData.nome) {
      showDefaultModal('error', 'Informe o nome do funcionário!');
      return;
    }

    const payload = {
      ...formData,
      idOrgao: orgaoId,
      idFuncionario: funcionario?.idFuncionario || null,
      idDepartamento: formData.idDepartamento ? Number(formData.idDepartamento) : null,
    };

    const request = funcionario
      ? axios.put(`${API_BASE_URL.ORGAO_FUNCIONARIO}/update`, payload, {
          headers: { Authorization: `Bearer ${token}` },
        })
      : axios.post(`${API_BASE_URL.ORGAO_FUNCIONARIO}/save`, payload, {
          headers: { Authorization: `Bearer ${token}` },
        });

    request
      .then(() => {
        if (formData.ehUsuario && !funcionario) {
          const cpfLimpo = (formData.cpf || '').replace(/\D/g, '');
          showDefaultModal(
            'success',
            `Usuário criado com sucesso!\n\nLogin: ${cpfLimpo}\nSenha inicial: 123456\n\nObrigatório alterar senha no primeiro acesso.`
          );
        }
        if (onSuccess) onSuccess();
      })
      .catch(error => {
        console.error('Erro ao salvar funcionário:', error);
        showDefaultModal('error', 'Erro ao salvar o funcionário!');
      });
  };

  if (!show) return null;

  return (
    <>
      <div
        className="modal show d-block"
        tabIndex="-1"
        style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}
      >
        <div className="modal-dialog modal-dialog-centered" style={{ maxWidth: '60vw', maxHeight: '80vh' }}>
          <div className="modal-content" style={{ maxHeight: '80vh', display: 'flex', flexDirection: 'column', borderRadius: '0.5rem', overflow: 'hidden' }}>
            <div
              className="modal-header text-white"
              style={{
                background: 'linear-gradient(45deg, rgb(30, 27, 75) 0%, rgb(55, 48, 163) 100%)',
                padding: '0.35rem 0.75rem',
              border: 'none',
              flexShrink: 0,
            }}
          >
              <h6 className="modal-title mb-0" style={{ fontSize: '0.80rem', lineHeight: 1 }}>
                <i className="bi bi-person-badge me-2"></i>
                {funcionario ? 'Editar Funcionário' : 'Novo Funcionário'}
              </h6>
              <button type="button" className="btn-close btn-close-white" onClick={onClose}></button>
            </div>
            <div className="modal-body" style={{ overflowY: 'auto' }}>
              <form onSubmit={handleSubmit}>
                <div className="row mb-3">
                  <div className="col-md-8">
                    <label className="form-label small fw-semibold">
                      Nome <span className="text-danger">*</span>
                    </label>
                    <input
                      type="text"
                      className="form-control form-control-sm"
                      name="nome"
                      value={formData.nome}
                      onChange={handleChange}
                      required
                    />
                  </div>
                  <div className="col-md-4">
                    <label className="form-label small fw-semibold">CPF</label>
                    <input
                      type="text"
                      className="form-control form-control-sm"
                      name="cpf"
                      value={formData.cpf}
                      onChange={handleChange}
                      maxLength={11}
                    />
                  </div>
                </div>
                <div className="row mb-3">
                  <div className="col-md-6">
                    <label className="form-label small fw-semibold">Cargo</label>
                    <input
                      type="text"
                      className="form-control form-control-sm"
                      name="cargo"
                      value={formData.cargo}
                      onChange={handleChange}
                    />
                  </div>
                  <div className="col-md-6">
                    <label className="form-label small fw-semibold">Departamento</label>
                    <select
                      className="form-select form-select-sm"
                      name="idDepartamento"
                      value={formData.idDepartamento}
                      onChange={handleChange}
                    >
                      <option value="">Selecione...</option>
                      {departamentos?.map(d => (
                        <option key={d.idDepartamento} value={d.idDepartamento}>
                          {d.nome}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
                <div className="row mb-3">
                  <div className="col-md-6">
                    <label className="form-label small fw-semibold">Email</label>
                    <input
                      type="email"
                      className="form-control form-control-sm"
                      name="email"
                      value={formData.email}
                      onChange={handleChange}
                    />
                  </div>
                  <div className="col-md-6">
                    <label className="form-label small fw-semibold">Telefone</label>
                    <input
                      type="text"
                      className="form-control form-control-sm"
                      name="telefone"
                      value={formData.telefone}
                      onChange={handleChange}
                    />
                  </div>
                </div>
                <div className="row mb-3">
                  <div className="col-md-4">
                    <label className="form-label small fw-semibold">Situação</label>
                    <select
                      className="form-select form-select-sm"
                      name="situacao"
                      value={formData.situacao}
                      onChange={handleChange}
                    >
                      <option value="ATIVO">ATIVO</option>
                      <option value="INATIVO">INATIVO</option>
                    </select>
                  </div>
                  <div className="col-md-4 d-flex align-items-end">
                    <div className="form-check">
                      <input
                        type="checkbox"
                        className="form-check-input"
                        name="ehUsuario"
                        checked={formData.ehUsuario}
                        onChange={handleChange}
                        id="ehUsuarioCheck"
                      />
                      <label className="form-check-label small fw-semibold" htmlFor="ehUsuarioCheck">
                        É usuário do sistema
                      </label>
                    </div>
                  </div>
                </div>
                <div className="d-flex justify-content-end gap-2 mt-4">
                  <button type="button" className="btn btn-secondary btn-sm" onClick={onClose}>
                    <i className="bi bi-x-circle me-1"></i>Cancelar
                  </button>
                  <button type="submit" className="btn btn-success btn-sm">
                    <i className="bi bi-check-lg me-1"></i>Salvar
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      <DefaultModal {...setDefaultModal} />
    </>
  );
}

export default OrgaoFuncionarioModal;
